var _circle, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "url(#paint0_linear_1965_24018)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.51 15H8.906a.486.486 0 01-.485-.485v-3.612h-.935A.486.486 0 017 10.418V8.87c0-.268.218-.485.486-.485h.935V7.61c0-.769.241-1.423.698-1.89.46-.471 1.1-.72 1.856-.72l1.222.002c.267 0 .485.218.485.485v1.437a.486.486 0 01-.486.485h-.823c-.25 0-.315.05-.328.066-.023.026-.05.098-.05.298v.612h1.14a.487.487 0 01.49.485l-.001 1.548a.486.486 0 01-.486.485h-1.143v3.612a.486.486 0 01-.485.485zm-1.502-.586h1.4V10.64c0-.178.146-.323.325-.323h1.304V8.97h-1.305a.324.324 0 01-.324-.324v-.874c0-.23.024-.49.197-.686.209-.236.538-.264.768-.264h.722V5.588l-1.121-.002c-1.213 0-1.966.776-1.966 2.024v1.037a.324.324 0 01-.324.324H7.587v1.345h1.097c.178 0 .324.146.324.324v3.774z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1965_24018",
    x1: 0,
    y1: 10,
    x2: 20,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook2);
export default __webpack_public_path__ + "static/media/Facebook2.7fe471682bdfc9395c2171f81a67efaf.svg";
export { ForwardRef as ReactComponent };